import { useEffect } from "react";
import { gsap } from "gsap";

interface ScaleXAnimationProps {
    svgElement: SVGElement;
    scaleAngle: number,
    animationSpeed: number;
  }

  const ScaleXAnimation: React.FC<ScaleXAnimationProps> = ({
    svgElement,
    scaleAngle = 10,
    animationSpeed = 1,
  }) => {
    useEffect(() => {
      gsap.to(svgElement, {
        scaleX: scaleAngle,
        duration: animationSpeed,
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
      });
    }, [svgElement, scaleAngle, animationSpeed]);
  
    return null;
  };
   
export default ScaleXAnimation;
